// extracted by mini-css-extract-plugin
module.exports = {"trailersWrapper":"tz","trailerHeader":"tA","trailers":"tB","trailer":"tC","imgWrapper":"tD","playWrapper":"tE","playImg":"tF","title":"tG","slipnslideArrow":"tH"};